/* eslint-disable */
import { phoneTypes } from '@ringcentral-integration/commons/enums/phoneTypes';
export default {
  [phoneTypes.business]: 'Telefone corporativo',
  [phoneTypes.extension]: 'Número do ramal',
  [phoneTypes.home]: 'Número da casa',
  [phoneTypes.mobile]: 'Telefone celular',
  [phoneTypes.phone]: 'Telefone',
  [phoneTypes.unknown]: 'Tipo de telefone desconhecido',
  [phoneTypes.company]: 'Número da empresa',
  [phoneTypes.direct]: 'Número direto',
  [phoneTypes.contact]: 'Telefone de contato',
  [phoneTypes.fax]: 'Fax',
  [phoneTypes.other]: 'Outro',
};

// @key: @#@"[phoneTypes.business]"@#@ @source: @#@"Business Phone"@#@
// @key: @#@"[phoneTypes.extension]"@#@ @source: @#@"Extension Number"@#@
// @key: @#@"[phoneTypes.home]"@#@ @source: @#@"Home Number"@#@
// @key: @#@"[phoneTypes.mobile]"@#@ @source: @#@"Mobile Phone"@#@
// @key: @#@"[phoneTypes.phone]"@#@ @source: @#@"Phone"@#@
// @key: @#@"[phoneTypes.unknown]"@#@ @source: @#@"Unknown Phone Type"@#@
// @key: @#@"[phoneTypes.company]"@#@ @source: @#@"Company Number"@#@
// @key: @#@"[phoneTypes.direct]"@#@ @source: @#@"Direct Number"@#@
// @key: @#@"[phoneTypes.contact]"@#@ @source: @#@"Contact Phone"@#@
// @key: @#@"[phoneTypes.fax]"@#@ @source: @#@"Fax"@#@
// @key: @#@"[phoneTypes.other]"@#@ @source: @#@"Other"@#@
